﻿import moment from 'moment';
import 'moment/locale/da';
import 'moment/locale/de';
import 'moment/locale/en-gb';
import $ from "jquery";
import {Calendar, EventApi, View} from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import {
    getLanguage,
    getPartySize,
    getQueryParameterByName,
    inIframe,
    isArrayUnique,
    isSingleBooking,
    Translator
} from "./utils";
import intlTelInput from 'intl-tel-input';
import 'jquery-validation';
import {API} from "./core";

if (window.location.href.includes("/booking")) {
    // $("#calendarParent").hide();
}

if (getLanguage() === "da") {
    require('jquery-validation/dist/localization/messages_da');
} else if (getLanguage() === "de") {
    require('jquery-validation/dist/localization/messages_de');
}

const daLocale = require('@fullcalendar/core/locales/da');
const deLocale = require('@fullcalendar/core/locales/de');
const enLocale = require('@fullcalendar/core/locales/en-gb');

let globalEvent: any = null;
let translator: Translator | null;
let calendar: any;
let closeLabel: string = "";
let currentLang: string = "";
let currentPhone: string = "";
// let eventsUrl: string = "";
let intlSinglePhone: null | intlTelInput.Plugin = null;
let intlSinglePartyPhone: intlTelInput.Plugin[] = [];
let formatter: any;

// TODO: Add to own file
($.fn as any).capitalize = function () {
    $.each(this, function () {
        var split = this.value.split(' ');
        for (var i = 0, len = split.length; i < len; i++) {
            split[i] = split[i].charAt(0).toUpperCase() + split[i].slice(1);
        }
        this.value = split.join(' ');
    });
    return this;
};

($.fn as any).ForceNumericOnly = function () {
    return this.each(function () {
        $(this).keydown(function (e) {
            var key = e.charCode || e.keyCode || 0;
            return (
                key == 8 ||
                key == 9 ||
                key == 13 ||
                key == 46 ||
                key == 110 ||
                key == 190 ||
                (key >= 35 && key <= 40) ||
                (key >= 48 && key <= 57) ||
                (key >= 96 && key <= 105));
        });
    });
};

const handleIfSingleBooking = () => {
    if (isSingleBooking()) {
        $('#loading').show();

        API.getSingleEvent().then((result) => {
            const tempResult = result[0];

            const tempEvent = {
                _def: {
                    extendedProps: tempResult
                },
                extendedProps: tempResult,
                ...tempResult
            }
            showEvent(tempEvent);

            $("#calendarParent").hide();
            $(".dialog-close").hide();

            $('#loading').hide();
            $("#submitEventForm")
                .css("box-shadow", "none")
                .css("width", "100%")
                .css("max-width", "965px")
                .css("height", "100%")
                .css("max-height", "500px")
                .css("margin", "0 auto")
                .css("background", "#f9f9f9")
                .css("border", "1px solid #eee")
                .css("border-radius", "3px")
                .css("margin-top", "20px")

            $("#submitEventForm").before('<img id="singleBookingLogo" src="http://www.ivanslystfiskeri.dk/CustomerData/Files/Images/Archive/3-grafik/logo_430.png">')

            $(".dialog")
                .css("background", "white")
                .css("transition", "none")
                .css("opacity", 1)
                .css("visibility", "visible")
        })
    }
};

const getEvent = () => {
    return globalEvent;
};

const showWebShop = (products: any) => {
    $("#webShopContainer").fadeIn("fast", () => {
        let htmlString = "";

        products.forEach((product: any) => {
            let name: string = product.name[currentLang];
            let description: string = product.description[currentLang];
            let price: string = currentLang === "da" ? (product.priceDKK / 100 + " kr.") : (product.priceEUR / 100 + " EUR");

            htmlString += "<div class='webShopItem' data-id='" + product.id + "'>";
            htmlString += `<img class="webShopItemImage" src="data:image/png;base64,${product.image}" />`;
            htmlString += "<div class='webShopItemDescription'><h3>" + name + "</h3>";
            htmlString += "<p>" + description + "</p>";
            htmlString += "<p>Pris: " + price + "</p>";
            htmlString += "<div class='webShopItemInput'><label>Antal:</label>";
            htmlString += "<input class='webShopItemInput' type='number' min='0' step='1' value='0' /></div></div>";
            htmlString += "</div>";
        })

        $("#webShopContainerContent").append(htmlString);
    });

    $("#webShopConfirmBtn").on("click", () => {
        $("#webShopContainer").hide(() => {
            $("#stepThree").fadeIn("fast");
        });
    })
}

const initializeSignUpProcedure = (products: any) => {
    $("#signUpStepOne").click(function () {
        if (inIframe()) {
            const convertedDate = new Date(window.startDate).getTime();
            return window.open(`https://ivans-lystfiskeri.leicht-thruesen.com/frontend?fromIframe=true&id=${globalEvent.obj_id}&lang=${currentLang}&startDate=${convertedDate}`, "_blank");
        }

        $("#stepOne").fadeOut("fast", function () {
            $("#stepTwo").fadeIn("fast");
        });
    });

    $("#signUpStepTwoBack").click(function () {
        $("#stepTwo").fadeOut("fast", function () {
            $("#stepOne").fadeIn("fast");
        });
    });

    $("#signUpStepTwo").click(function () {
        validationRequirements();

        const firstName = $('input[name="firstname"]');
        const lastName = $('input[name="lastname"]');
        const phone = $('input[name="phone"]');
        const email = $('input[name="email"]');
        if (firstName.valid() && lastName.valid() && $('input[name="amountOfPersons"]').valid()) {
            if (phone.valid() && email.valid()) {
                $("#enterPartyInformation").empty();

                if (getPartySize() > 1) {
                    $("#managerContainer").show();

                    $("#stepTwo").fadeOut("fast", function () {
                        $("#stepTwoAndAHalf").fadeIn("fast");

                        const entryTemplate = $("#templatePartyEntry");
                        entryTemplate.find("#party_firstname").val(firstName.val() as string);
                        entryTemplate.find("#party_lastname").val(lastName.val() as string);
                        entryTemplate.find("#party_phone").val(phone.val() as string);
                        entryTemplate.find("#party_email").val(email.val() as string);
                        entryTemplate.find("#party_firstname").attr("disabled", "disabled");
                        entryTemplate.find("#party_lastname").attr("disabled", "disabled");
                        entryTemplate.find("#party_phone").attr("disabled", "disabled");
                        entryTemplate.find("#party_email").attr("disabled", "disabled");

                        for (let i = 0; i < getPartySize(); i++) {
                            const template = entryTemplate.clone();
                            template.removeClass("hidden");
                            template.removeAttr('id');
                            if (i > 0) {
                                template.find("#party_firstname").val("");
                                template.find("#party_lastname").val("");
                                template.find("#party_phone").val("");
                                template.find("#party_email").val("");
                                template.find("#party_firstname").removeAttr("disabled");
                                template.find("#party_lastname").removeAttr("disabled");
                                template.find("#party_phone").removeAttr("disabled");
                                template.find("#party_email").removeAttr("disabled");

                                template.find(".party_firstname_class").attr("id", "party_firstname_" + i);
                                template.find(".party_lastname_class").attr("id", "party_lastname_" + i);
                                template.find(".party_phone_class").attr("id", "party_phone_" + i);
                                template.find(".party_email_class").attr("id", "party_email_" + i);
                            }
                            template.find(".partyEntryId").html(String(i + 1));

                            template.find(".party_firstname_class").attr("name", "party_firstname_" + i);
                            template.find(".party_lastname_class").attr("name", "party_lastname_" + i);
                            template.find(".party_phone_class").attr("name", "party_phone_" + i);
                            template.find(".party_email_class").attr("name", "party_email_" + i);

                            $("#enterPartyInformation").append(template);
                        }

                        const phoneElements = document.querySelectorAll("#enterPartyInformation .party_phone_class");
                        phoneElements.forEach(element => {
                            const language = getLanguage();
                            let newLanguage: string = "gb";
                            if (language === "da") {
                                newLanguage = "dk";
                            } else if (language === "de") {
                                newLanguage = "de";
                            } else {
                                newLanguage = "gb";
                            }

                            const telInput = intlTelInput(element, {
                                initialCountry: newLanguage,
                                preferredCountries: ["dk", "de", "gb"],
                                separateDialCode: true,
                                autoHideDialCode: true,
                                utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.min.js"
                            });

                            intlSinglePartyPhone.push(telInput);
                        })
                    });
                } else {
                    $("#managerContainer").hide();

                    $("#stepTwo").fadeOut("fast", () => {
                        if (getEvent().isWebshopActivated) {
                            showWebShop(products);
                        } else {
                            $("#stepThree").fadeIn("fast");
                        }
                    });
                }

            }
        }
    });

    // TODO: Show webshop when more than one is booking
    $("#signUpStepTwoAndAHalf").click(function () {
        //TODO: validate before click
        $("#uniquePhoneNumbers").hide();
        $("#manager").html("");

        if (translator) {
            if (getPartySize() > 1) {
                translator.setText("addressLabel", "CONTACT_PERSON_ADDRESS_TEXT");
                translator.setPlaceholder("address", "CONTACT_PERSON_ADDRESS_TEXT");
            } else {
                translator.setText("addressLabel", "ADDRESS_TEXT");
                translator.setPlaceholder("address", "ADDRESS_TEXT");
            }
        }

        const partyInformationWrapper = $("#enterPartyInformation");
        const firstNames = partyInformationWrapper.find(".party_firstname_class");
        const lastNames = partyInformationWrapper.find(".party_lastname_class");
        const phones = partyInformationWrapper.find(".party_phone_class");
        const emails = partyInformationWrapper.find(".party_email_class");

        const phoneNumbers = [...phones].map((phone: any, index) => {
            return intlSinglePartyPhone[index].getNumber();
        })

        let firstNamesValid: boolean = true;
        let lastNamesValid: boolean = true;
        let phonesValid: boolean = true;
        let emailsValid: boolean = true;
        for (let i = 0; i < getPartySize(); i++) {
            if (!firstNames.eq(i).valid()) {
                firstNamesValid = false;
            }
            if (!lastNames.eq(i).valid()) {
                lastNamesValid = false;
            }
            if (!phones.eq(i).valid()) {
                phonesValid = false;
            }
            if (!emails.eq(i).valid()) {
                emailsValid = false;
            }
        }

        if (!isArrayUnique(phoneNumbers)) {
            phonesValid = false;
            $("#uniquePhoneNumbers").show();
        }

        if (firstNamesValid && lastNamesValid && phonesValid && emailsValid) {
            $("#stepTwoAndAHalf").fadeOut("fast", () => {
                if (getEvent().isWebshopActivated) {
                    showWebShop(products);
                } else {
                    $("#stepThree").fadeIn("fast");
                }
            });

            for (let i = 0; i < getPartySize(); i++) {
                const firstName: string = firstNames.eq(i)[0].value;
                const lastName: string = lastNames.eq(i)[0].value;
                const name = firstName + " " + lastName;
                const option = new Option(name, phones.eq(i)[0].value);

                $(option).html(name);
                $("#manager").append(option);
            }
        }
    });

    $("#signUpStepTwoAndAHalfBack").click(function () {
        $("#stepTwoAndAHalf").fadeOut("fast", function () {
            $("#stepTwo").fadeIn("fast");
        });
    });

    $("#signUpStepThreeBack").click(function () {
        if (getPartySize() > 1) {
            $("#stepThree").fadeOut("fast", function () {
                $("#stepTwoAndAHalf").fadeIn("fast");
            });
        } else {
            $("#stepThree").fadeOut("fast", function () {
                $("#stepTwo").fadeIn("fast");
            });
        }
    });

    $("#signUpStepThree").on("click", () => {
        if ($('input[name="terms"]').valid() && $('input#address').valid()) {
            $("#stepThree").fadeOut("fast", () => {
                const phoneSelector = $("#phone");
                const emailSelector = $("#email");
                const noteSelector = $("#note");
                const addressSelector = $("#address");

                let phoneNumber: string = phoneSelector.val() as string;
                if (intlSinglePhone) {
                    phoneNumber = intlSinglePhone.getNumber();
                }

                $("#stepFour").fadeIn("fast");

                let startTime = $("#startTime").html();
                if (startTime === null || startTime === undefined || startTime === "") {
                    startTime = $("#allDayStartTime").html()
                }

                let endTime = $("#endTime").html();
                if (endTime === null || endTime === undefined || endTime === "") {
                    endTime = $("#allDayEndTime").html()
                }

                $("#validateStart").html(startTime);
                $("#validateEnd").html(endTime);
                $("#validateName").html($("#firstname").val() + " " + $("#lastname").val());
                $("#validatePhone").html(phoneNumber);

                $("#validateEmail").html(emailSelector && emailSelector.val() && (emailSelector.val() as string).trim().length > 0 ? emailSelector.val() as string : '-');
                $("#validateNote").html(noteSelector && noteSelector.val() && (noteSelector.val() as string).trim().length > 0 ? noteSelector.val() as string : '-');
                $("#validateAddress").html(addressSelector.val() as string);

                $("#validateAmount").html($("#amountOfPersons").val() as string);

                const seats = Number($("#amountOfPersons").val());
                let total = 0;
                switch (currentLang) {
                    case "da":
                        total = total + ((Number(globalEvent.pricePerTicketDKK)) * seats);
                        break;
                    case "en":
                    case "de":
                        total = total + ((Number(globalEvent.pricePerTicketEUR)) * seats);
                        break;
                }

                switch (currentLang) {
                    case "da":
                        $("#validateWebShopSeats").html(`${seats} plads${seats === 1 ? "" : "er"} til ${formatter.format((total / seats) / 100)} pr. plads.`);
                        break;
                    case "en":
                        $("#validateWebShopSeats").html(`${seats} seat${seats === 1 ? "" : "s"} til ${formatter.format((total / seats) / 100)} pr. seat.`);
                        break;
                    case "de":
                        $("#validateWebShopSeats").html(`${seats} Plätz${seats === 1 ? "" : "e"} für ${formatter.format((total / seats) / 100)} pro Stück.`);
                        break;
                }

                let htmlString = "";
                $("#webShopContainerContent .webShopItem").each(function () {
                    const productId = Number($(this).attr("data-id"));
                    const product = products.find((tempProduct: any) => {
                        return tempProduct.id === productId;
                    })
                    const amount = Number($(this).find("input").val());

                    if (amount && amount > 0) {
                        let language = getLanguage();
                        let price = product.priceDKK;
                        switch (language) {
                            case "de":
                                price = product.priceEUR * amount;
                                break;
                            case "da":
                                price = product.priceDKK * amount;
                                break;
                            case "en-gb":
                                price = product.priceGBP * amount;
                                break;
                        }
                        const formattedPrice = formatter.format((price / amount) / 100);

                        total += price;
                        switch (currentLang) {
                            case "da":
                                htmlString += `<div class='selectedWebShopItem'><p>${amount}x ${product.name[currentLang]} til ${formattedPrice} pr. stk.</p></div>`;
                                break;
                            case "de":
                                htmlString += `<div class='selectedWebShopItem'><p>${amount}x ${product.name[currentLang]} für ${formattedPrice} pro stück.</p></div>`;
                                break;
                            case "en":
                                htmlString += `<div class='selectedWebShopItem'><p>${amount}x ${product.name[currentLang]} for ${formattedPrice} pr. item.</p></div>`;
                                break;
                        }
                    }
                });
                if (total > 0) {
                    switch (currentLang) {
                        case "da":
                            htmlString += "<div id='totalWebShopPrice'><b>Total:</b> " + formatter.format(total / 100) + "</div>";
                            break;
                        case "de":
                            htmlString += "<div id='totalWebShopPrice'><b>Gesamt:</b> " + formatter.format(total / 100) + "</div>";
                            break;
                        case "en":
                            htmlString += "<div id='totalWebShopPrice'><b>Total:</b> " + formatter.format(total / 100) + "</div>";
                            break;
                    }
                }

                if (total === 0) {
                    switch (currentLang) {
                        case "da":
                            htmlString = "Ingen tilvalg valgt.";
                            break;
                        case "de":
                            htmlString = "Keine Optionen ausgewählt.";
                            break;
                        case "en":
                            htmlString = "No options selected.";
                            break;
                    }
                }

                $("#validateWebShopContentItems").html(htmlString)
            });
        }
    });

    $("#signUpStepFourBack").click(function () {
        $("#stepFour").fadeOut("fast", function () {
            $("#stepThree").fadeIn("fast");
        });
    });

    $("#signUpStepFour").click(function () {
        const participants: any[] = [];
        const partyInformationWrapper = $("#enterPartyInformation");
        const firstNames = partyInformationWrapper.find(".party_firstname_class");
        const lastNames = partyInformationWrapper.find(".party_lastname_class");
        // TODO:
        // const phones = partyInformationWrapper.find(".party_phone_class");
        const emails = partyInformationWrapper.find(".party_email_class");

        for (let i = 0; i < getPartySize(); i++) {
            participants[i] = {manager: false};

            if (i === 0) {
                participants[i].firstName = $('#firstname').val();
                participants[i].lastName = $('#lastname').val();
                participants[i].mail = $('#email').val();
                participants[i].acceptNews = $("#news").prop("checked");
                const addressSelector = $('#address');
                if (addressSelector.val() != null && addressSelector.val() != "") {
                    participants[i].address = addressSelector.val();
                }
                participants[i].phone = intlSinglePhone?.getNumber();
            } else {
                participants[i].firstName = firstNames.eq(i).val();
                participants[i].lastName = lastNames.eq(i).val();
                participants[i].acceptNews = $("#news").prop("checked");
                if (emails.eq(i).val() != null && emails.eq(i).val() != "") {
                    participants[i].mail = emails.eq(i).val();
                }
                participants[i].phone = intlSinglePartyPhone[i].getNumber();
            }
        }

        if (getPartySize() > 1) {
            const managerPhone = ($("#manager").children("option:selected").val() as string).trim().split(" ").join("");

            participants.forEach(participant => {
                participant.manager = participant.phone.includes(managerPhone);
                if (participant.manager) {
                    participant.address = $('#address').val();
                } else {
                    participant.address = undefined;
                }
            })
        } else {
            participants.forEach(participant => {
                participant.manager = true;
            })
        }

        let orderedProducts: any[] = [];
        $("#webShopContainerContent .webShopItem").each(function () {
            const productId = Number($(this).attr("data-id"));
            const amount = Number($(this).find("input").val());

            if (amount && !isNaN(Number(amount))) {
                orderedProducts.push({productId: productId, quantity: amount});
            }
        });

        const seats = Number($('#amountOfPersons').val());

        const booking = {
            seats: String(seats),
            comment: $('#note').val(),
            language: currentLang,
            eventID: parseInt($('#eventId').val() as string),
            participants: participants,
            orderedProducts: orderedProducts.length > 0 ? orderedProducts : undefined,
        };

        console.log("part", participants)

        if (booking.participants[0] && booking.participants[0].mail && booking.participants[0].mail.trim().length == 0) {
            delete booking.participants[0].mail;
        }

        if (booking.participants[0] && booking.participants[0].phone && booking.participants[0].phone.trim().length == 0) {
            delete booking.participants[0].phone;
        }

        if (booking.comment && (booking.comment as string).trim().length == 0) {
            delete booking.comment;
        }

        $("#signUpStepFour").prop("disabled", true);

        $.ajax({
            url: `${API.baseUrl}booking`,
            type: 'POST',
            data: {data: JSON.stringify(booking)},
            success: function (result) {
                if (result.paymentLink) {
                    location.href = result.paymentLink;
                    return;
                }

                window.isEventsRefetched = true;
                calendar.refetchEvents();

                $("#signUpStepFour").prop("disabled", false);

                $("#stepFour").fadeOut("fast", function () {
                    $("#stepFive").fadeIn("fast");
                });
            },
            error: function (e) {
                $("#signUpStepFour").prop("disabled", false);
            }
        });
    });
};

const validationRequirements = () => {
    const phoneSelector = $("#phone");
    const emailSelector = $("#email")
    const addressSelector = $("#address")

    const phone = (phoneSelector.val() as string).trim();
    const email = (emailSelector.val() as string).trim();
    const address = (addressSelector.val() as string).trim();

    let isPhoneRequired: boolean = true;
    let isEmailRequired: boolean = true;
    let isAddressRequired: boolean = true;

    if (phone.length > 0) {
        isEmailRequired = false;
        emailSelector.prop("required", false);
    }

    if (email.length > 0) {
        isPhoneRequired = false;
        phoneSelector.prop("required", false);
    }

    if (address.length > 0) {
        isAddressRequired = false;
        addressSelector.prop("required", false);
    }

    $('#submitEventForm').validate({
        rules: {
            email: {
                required: isEmailRequired,
                email: true
            },
            firstname: {
                required: true
            },
            lastname: {
                required: true
            },
            phone: {
                required: isPhoneRequired,
            },
            amountOfPersons: {
                required: true,
                number: true
            },
            terms: {
                required: true
            },
            address: {
                required: isAddressRequired
            }
        }
    });
};

const handlePhoneInputs = (language) => {
    const phoneElement = document.getElementById("phone");
    if (intlSinglePhone) {
        console.log("des")
        intlSinglePhone.destroy();
    }

    if (phoneElement) {
        let newLanguage: string = "gb";
        if (language === "da") {
            newLanguage = "dk";
        } else if (language === "de") {
            newLanguage = "de";
        } else {
            newLanguage = "gb";
        }

        intlSinglePhone = intlTelInput(phoneElement, {
            initialCountry: newLanguage,
            preferredCountries: ["dk", "de", "gb"],
            separateDialCode: true,
            autoHideDialCode: true,
            utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.min.js"
        })
    }
}

const handleInputs = () => {
    // TODO: remove fails
    $('input#firstname').on('keyup', function () {
        $(this).capitalize();
    }).capitalize();

    $('input#lastname').on('keyup', function () {
        $(this).capitalize();
    }).capitalize();

    $('input#phone').on('keyup', function () {
        $(this).ForceNumericOnly();
    }).ForceNumericOnly();

    $('input#amountOfPersons').on('keyup', function () {
        $(this).ForceNumericOnly();
    }).ForceNumericOnly();
};

function isSameDay(startDate, endDate) {
    return endDate.valueOf() == startDate.valueOf();
}

const showEvent = (currentEvent: any) => {
    handlePhoneInputs(currentLang);

    const isPaymentActivated = currentEvent._def.extendedProps.isPaymentActivated;
    if (isPaymentActivated) {
        $("#pricePerSeatWrapper").show();
        $("#validateWebShopContent").show();

        /* const start = new Date(currentEvent._instance.range.start);
        const end =  new Date(currentEvent._instance.range.end);

        const startDate = new Date(start.getFullYear(), start.getMonth(), start.getDate());
        const endDate = new Date(end.getFullYear(), end.getMonth(), end.getDate());
        const isEventsOnSameDay = isSameDay(startDate,endDate);
        console.table("her", currentEvent)

        if(isEventsOnSameDay) {
          $("#paymentNoteMultiDay").hide();
          $("#paymentNoteSingleDay").show();
        } else {
          $("#paymentNoteMultiDay").show();
          $("#paymentNoteSingleDay").hide();
        } */

        switch (currentLang) {
            case "da":
                const pricePerSeatDkk = currentEvent._def.extendedProps.pricePerTicketDKK;
                $("#price").html(formatter.format(pricePerSeatDkk / 100))
                break;
            case "en":
            case "de":
                const pricePerSeatEur = currentEvent._def.extendedProps.pricePerTicketEUR;
                $("#price").html(formatter.format(pricePerSeatEur / 100))
                break;
        }

        if (translator) {
            translator.setText("signUpStepFour", "CONFIRM_AND_PAY_BTN");
        }
    } else {
        $("#validateWebShopContent").hide();
        $("#pricePerSeatWrapper").hide();

        if (translator) {
            translator.setText("signUpStepFour", "CONFIRM_BTN");
        }
    }

    let start = currentEvent.start;
    if (typeof start === "string") {
        start = moment(start, "DD-MM-YYYY").toDate();
    }
    const end = currentEvent.end;
    const title = currentEvent.title;
    const originalEvent = currentEvent;
    currentEvent = currentEvent.extendedProps;
    globalEvent = currentEvent;
    $("#maxAmountOfPersons").html(currentEvent.available);
    $("#amountOfPersons").prop("max", currentEvent.available);

    if (currentEvent.status == "cancelled") {
        $("#signUpStepOne").hide();
        $("#occupiedBtn").hide();
        $("#cancelledBtn").show();
        $("#occupiedBusinessBtn").hide();

    } else if (currentEvent.status == "occupied" && currentEvent.businessTrip == true) {
        $("#signUpStepOne").hide();
        $("#cancelledBtn").hide();
        $("#occupiedBtn").hide();
        $("#occupiedBusinessBtn").show();
    } else if (currentEvent.status == "occupied") {
        $("#signUpStepOne").hide();
        $("#cancelledBtn").hide();
        $("#occupiedBtn").show();
        $("#occupiedBusinessBtn").hide();
    } else {
        $("#signUpStepOne").show();
        $("#occupiedBtn").hide();
        $("#cancelledBtn").hide();
        $("#occupiedBusinessBtn").hide();
    }

    $("#stepOne").show();
    $("#stepTwo").hide();
    $("#stepThree").hide();
    $("#stepFour").hide();
    $("#stepFive").hide();

    $("#eventContent input").each(function () {
        $(this).val("");
    });

    $("#eventContent textarea").each(function () {
        $(this).val("");
    });

    $("#terms").prop("checked", false);

    handleEventDate(originalEvent);

    $("#eventInfo").html(currentEvent.description);
    if (currentEvent.imageUrl) {
        $("#eventInfo").append("<img class='currentEventImage' src='" + currentEvent.imageUrl + "' />");
    }

    const language = getLanguage();
    let initialTermsAnchor: string = "";
    const startDate = moment(originalEvent.start);
    const endDate =   moment(originalEvent.end);
    const diff = endDate.diff(startDate, 'days')
    switch (language) {
        case "da":
            initialTermsAnchor = "https://ivanslystfiskeri.dk/2023-eendagstur.aspx";
            if (diff > 0) {
                initialTermsAnchor = "https://ivanslystfiskeri.dk/2023-fleredagesture.aspx"
            }
            break;
        case "de":
            initialTermsAnchor = "https://ivans-lystfiskeri.dk/de/1-tages-fahrt.aspx";
            if (diff > 0) {
                initialTermsAnchor = "https://ivans-lystfiskeri.dk/de/mehrere-tages-fahrt.aspx"
            }
            break;
    }

    switch (language) {
        case "da":
            $("#initialTerms").html("Se vores betingelser <a href='" + initialTermsAnchor + "' target='_blank' style='color:orangered;text-decoration: underline;'>her</a>")
            break;
        case "de":
            $("#initialTerms").html("Siehe unsere Bedingungen <a href='" + initialTermsAnchor + "' target='_blank' style='color:orangered;text-decoration: underline;'>hier</a>")
            break;
        case "en":
            $("#initialTerms").html("See our terms <a href='" + initialTermsAnchor + "' target='_blank' style='color:orangered;text-decoration: underline;'>here</a>")
            break;
    }

    const dialogTitle = document.querySelector(".dialog-title");
    if (dialogTitle) {
        dialogTitle.innerHTML = title;
    }

    if (currentEvent.available !== undefined && currentEvent.available >= 12) {
        $("#available").html("12");
    } else {
        $("#available").html(currentEvent.available);
    }

    if (currentEvent.tickets !== undefined && currentEvent.tickets >= 12) {
        $("#total").html("12");
    } else {
        $("#total").html(currentEvent.tickets);
    }

    $("#eventId").val(currentEvent.obj_id);

    if (currentEvent.status === "occupied") {
        $("#occupiedBtn").prop("disabled", true);
        $("#occupiedBusinessBtn").prop("disabled", true);
    }

    const eventDate = moment(start).valueOf();
    const todayDate = new Date().getTime();
    const isEventInFuture: boolean = eventDate > todayDate;
    if (isEventInFuture) {
        $("#signUpStepOne").prop("disabled", false);
    } else {
        $("#signUpStepOne").prop("disabled", true);
    }
};

const handleEventDate = (event: any) => {
    window.startDate = moment(event.start, "DD-MM-YYYY").toDate();

    if (isSingleBooking()) {
        if (event.end == null && event.allDay === true) {
            $("#allDayFalse").hide();
            $("#allDayTrue").show();
            $("#allDayStartTime").html(moment(event.start, "DD-MM-YYYY").format("Do MMMM"));
            $("#allDayEndTime").html(moment(event.start, "DD-MM-YYYY").format("Do MMMM"));
        } else if (event.end != null && event.allDay === true) {
            $("#allDayFalse").hide();
            $("#allDayTrue").show();
            $("#allDayStartTime").html(moment(event.start, "DD-MM-YYYY").format("Do MMMM"));
            $("#allDayEndTime").html(moment(event.end, "DD-MM-YYYY").format("Do MMMM"));
        } else {
            $("#allDayFalse").show();
            $("#allDayTrue").hide();
            $("#startTime").html(moment(event.start + " " + event.startTime, "DD-MM-YYYY HH:mm").format("Do MMMM HH:mm"));
            $("#endTime").html(moment(event.end + " " + event.endTime, "DD-MM-YYYY HH:mm").format("Do MMMM HH:mm"));
        }
    } else {
        if (event.end == null && event.allDay === true) {
            $("#allDayFalse").hide();
            $("#allDayTrue").show();
            $("#allDayStartTime").html(moment(event.start).format("Do MMMM"));
            $("#allDayEndTime").html(moment(event.start).format("Do MMMM"));
        } else if (event.end != null && event.allDay === true) {
            $("#allDayFalse").hide();
            $("#allDayTrue").show();
            $("#allDayStartTime").html(moment(event.start).format("Do MMMM"));
            $("#allDayEndTime").html(moment(event.end).format("Do MMMM"));
        } else {
            $("#allDayFalse").show();
            $("#allDayTrue").hide();
            $("#startTime").html(moment(event.start).format("Do MMMM HH:mm"));
            $("#endTime").html(moment(event.end).format("Do MMMM HH:mm"));
        }
    }
};

const renderCalendar = () => {
    const calendarElement = document.getElementById('calendar');

    if (!calendarElement) {
        return;
    }

    calendar = new Calendar(calendarElement, {
        defaultDate: new Date(),
        editable: false,
        height: "parent",
        eventLimit: false,
        locales: [daLocale, deLocale, enLocale],
        locale: getLanguage(),
        scrollTime: "08:00:00",
        loading(isLoading: boolean): void {
            if (isLoading) {
                $('#loading').show();
            } else {
                $('#loading').hide();
            }
        },
        header: {
            left: 'prev,next today',
            center: 'title',
            right: 'dayGridMonth,timeGridWeek,timeGridDay,list'
        },
        eventRender(arg: { isMirror: boolean; isStart: boolean; isEnd: boolean; event: EventApi; el: HTMLElement; view: View }): void {
            const element: HTMLElement = arg.el;
            const event: any = arg.event;
            element.setAttribute('href', 'javascript:void(0);');

            if (event.extendedProps.private === true) {
                element.classList.add("private-event");
            } else {
                element.addEventListener("click", () => {
                    showEvent(event);

                    const dialog = document.getElementById("eventContent");
                    if (dialog) {
                        dialog.classList.add("dialog-visible");
                    }
                });
            }

            const eventId = getQueryParameterByName("id");
            const currentId = event._def.extendedProps.obj_id;
            if (eventId && eventId === currentId && window.isEventsRefetched !== true) {
                window.isEventsRefetched = false;
                showEvent(event);
                const dialog = document.getElementById("eventContent");
                if (dialog) {
                    dialog.classList.add("dialog-visible");
                    $("#signUpStepOne").click();
                }
            }
        },
        eventMouseEnter: (event) => {
            const imageUrl = event.event._def.extendedProps.imageUrl;
            const parent = $(event.el);

            if (parent && imageUrl && imageUrl != "") {
                var tooltip = '<div class="tooltipEvent"><img alt="tooltip" src="' + imageUrl + '" width="200px" /></div>';
                $("body").append(tooltip);

                parent.mouseover(function (e) {
                    $(this).css('z-index', 10000);
                    $('.tooltipEvent').fadeIn('500');
                    $('.tooltipEvent').fadeTo('10', 1.9);
                }).mousemove(function (e) {
                    $('.tooltipEvent').css('top', e.pageY + 10);

                    if (e.pageX > (window.innerWidth - 220)) {
                        $('.tooltipEvent').css('left', e.pageX - 220);
                    } else {
                        $('.tooltipEvent').css('left', e.pageX + 20);
                    }
                });
            }
        },
        eventMouseLeave: () => {
            $('.tooltipEvent').remove();
        },
        eventSourceSuccess: (rawEvents: any) => {
            return changeDateFormat(rawEvents);
        },
        events: (fetchInfo: { end: string | number | void | moment.Moment | Date | (string | number)[] | moment.MomentInputObject | undefined; }, successCallback: (arg0: any[]) => void) => {
            let endMonth;
            let endYear;
            const end = moment(fetchInfo.end);

            if (end.month() == 0) {
                endMonth = 12;
                endYear = end.year() - 1;
            } else {
                endMonth = end.month();
                endYear = end.year();
            }

            API.getEvents(endMonth, endYear).then(result => {
                successCallback(result)
            })
        },
        plugins: [dayGridPlugin, timeGridPlugin, listPlugin],
        defaultView: 'dayGridMonth'
    });

    calendar.render();

    const startDate = getQueryParameterByName("startDate");
    if (startDate) {
        calendar.gotoDate(new Date(Number(startDate)))
    }
};

const changeDateFormat = (events: any[]) => {
    for (const event of events) {
        if (event.start) {
            event.start = moment(event.start + " " + event.startTime, "DD-MM-YYYY hh:mm").format();
        }

        if (event.end) {
            event.end = moment(event.end + " " + event.endTime, "DD-MM-YYYY hh:mm").format();
        }

        delete event.startTime;
        delete event.endTime;

        switch (event.color) {
            case "green":
                event.color = "#5CB85C";
                break;
            case "red":
                event.color = "#D9534F";
                break;
            case "orange":
                event.color = "#D9534F";
                break;
            case "darkblue":
                event.color = "#3D6FBF";
                break;
            case "lightblue":
                event.color = "#699DF0";
                break;
            default:
                event.color = "#F0AD4E";
        }
    }
};

const runApp = async () => {
    const products = await API.getWebShopContent();
    const language = getLanguage();
    let currency = "DKK";

    switch (language) {
        case "de":
            currentLang = "de";
            closeLabel = "Geschlössen";
            currentPhone = "de";
            moment.locale('de-DE');
            currency = "EUR";
            break;
        case "da":
            currentLang = "da";
            closeLabel = "Luk";
            currentPhone = "dk";
            moment.locale('da-DK');
            currency = "DKK";
            break;
        case "en-gb":
            currentLang = "en";
            closeLabel = "Close";
            currentPhone = "gb";
            moment.locale('en-GB');
            currency = "GBP";
            break;
        default:
            currentLang = "da";
            closeLabel = "Luk";
            currentPhone = "dk";
            moment.locale('da-DK');
            break;
    }

    formatter = new Intl.NumberFormat(language, {
        style: 'currency',
        currency: currency,
    });

    translator = new Translator(currentLang as any);

    renderCalendar();

    handleIfSingleBooking();
    initializeSignUpProcedure(products);
    validationRequirements();
    handleInputs();

    const dialogCloseBtn = document.querySelector(".dialog-close");
    const dialogCloseBtn2 = document.querySelector("#closeBookingModal");

    const dialog = document.querySelector(".dialog");
    if (dialogCloseBtn && dialog) {
        dialogCloseBtn.addEventListener("click", () => {

            dialog.classList.remove("dialog-visible");
            // TODO: Reset state
            $("#enterPartyInformation").empty();
            intlSinglePartyPhone = [];
        });

        if (dialogCloseBtn2) {

            dialogCloseBtn2.addEventListener("click", () => {
                dialog.classList.remove("dialog-visible");
                // TODO: Reset state
                $("#enterPartyInformation").empty();
                intlSinglePartyPhone = [];
            });


        }
    }
};

document.addEventListener("DOMContentLoaded", () => {
    void runApp();
});

